export default {
    lang: {
        name: 'Users played'
    }
}